import { useNavigate } from "react-router-dom"
import { Emitter, Event } from "../../../../../features/event-emitter"
import { ModalId, showErrorStrToast, useUIActions } from "../../../../../features/ui"
import { useCreditPaymentService } from "../../../services/creditPaymentService"

export const useActions = () => {
    const navigate = useNavigate()

    const { annulCreditPayment } = useCreditPaymentService()

    const { closeModal } = useUIActions()

    const submitAnnulCreditPayment = async (creditPaymentId: string) => {
        Emitter.emit(Event.DB_REMOVE, 'Anulando cobro...')

        try {
            await annulCreditPayment(creditPaymentId)

            Emitter.emit(Event.DB_REMOVE_DONE)
            navigate(-1)
        } catch (error) {
            closeModal(ModalId.SPINNER)
            showErrorStrToast(error instanceof Error ? error.message : 'No se pudo anular el cobro.')
        }
    }

    return {
        submitAnnulCreditPayment
    }
}
